import React from 'react';
import { withRouter } from 'react-router-dom';
import MenuItem from './NavItem';

const MenuComponent = ({ festival, location, ...props }) => (
  <ul className="list-none p-0">
    <MenuItem
      title="Festival Info"
      icon={['fas', 'circle-info']}
      location={location}
      path={`festival/${festival ? festival.festivalId : 'new'}`}
    />
    <MenuItem
      location={location}
      title="Stages"
      icon={['fas', 'music']}
      path="stages"
    />
    <MenuItem
      location={location}
      title="Attractions"
      icon={['fas', 'flag']}
      path="attractions"
    />
    <MenuItem
      location={location}
      title="Vendors"
      icon={['fas', 'id-card']}
      path="vendors"
    />
    <MenuItem
      location={location}
      title="Sponsors"
      icon={['far', 'handshake']}
      path="sponsors"
    />
    <MenuItem
      location={location}
      title="Services"
      icon={['fas', 'bell-concierge']}
      path="services"
    />
    <MenuItem
      location={location}
      title="FAQ"
      icon={['far', 'circle-question']}
      path="faq"
    />
    <MenuItem
      location={location}
      title="Push Notification"
      icon={['far', 'envelope']}
      path="push-notification"
    />
  </ul>
);

export default withRouter(MenuComponent);
